export const enum Feature {
    CAPTCHA = "captcha",
    APKSIGNING = "apk_signing",
    VEHICLE_TRIMS = "vehicle_trims",
    AI_CHATBOT = "ai_chatbot",
    MMC = "mmc",
}
